import { RootStore } from './rootStore'
import * as _ from 'lodash'
import { makeAutoObservable, runInAction } from 'mobx'
export default class ArchiveStore {
  private rootStore: RootStore
  private maxArchiveBytesSize = 52428800
  selectedFileIds: Array<string>
  selectedBytes: number
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    this.selectedFileIds = []
    this.selectedBytes = 0
    makeAutoObservable(this)
  }
  resetStore = () => {
    this.selectedFileIds = []
    this.selectedBytes = 0
  }
  isFileSelected = (uniqueKey: string) => {
    return this.selectedFileIds.indexOf(uniqueKey) !== -1 ? true : false
  }
  deselectAllFiles = () => {
    _.forEach(this.selectedFileIds, (selectedFile) => {
      this.deselectFile(selectedFile)
    })
  }
  selectedFilesCount = () => {
    return this.selectedFileIds.length
  }
  get totalSelectedBytes() {
    //50mb limit
    const total = (this.selectedBytes / this.maxArchiveBytesSize) * 100
    return total
  }

  get doesArchiveExceedMaxSize() {
    return this.selectedBytes > this.maxArchiveBytesSize
  }

  get maxArchiveSize() {
    return this.maxArchiveBytesSize
  }
  selectFile = (uniqueKey: string) => {
    runInAction(() => {
      const fileObject = this.rootStore.FileStore.getFileObjectByKey(uniqueKey)
      //inverse current state, as new state of selected.
      const fileObjectSelected = !fileObject.selected
      if (fileObjectSelected) {
        this.selectedFileIds.push(uniqueKey)
        //update the file object's selected state with new value.
        fileObject.selected = fileObjectSelected
        this.rootStore.FileStore.updateFileObjectInDirectory(fileObject)
        this.selectedBytes += fileObject.size
      } else {
        this.deselectFile(uniqueKey)
      }
    })
  }

  deselectFile = (uniqueKey: string) => {
    runInAction(() => {
      const fileObject = this.rootStore.FileStore.getFileObjectByKey(uniqueKey)
      this.selectedFileIds = this.selectedFileIds.filter((ids) => fileObject.uniqueKey !== ids)
      fileObject.selected = false
      this.rootStore.FileStore.updateFileObjectInDirectory(fileObject)
      this.selectedBytes -= fileObject.size
    })
  }

  getKeysFromSelected = () => {
    return runInAction(() => {
      return _.map(this.selectedFileIds, (fileID) => {
        return this.rootStore.FileStore.getFileObjectByKey(fileID).key
      })
    })
  }
}
